function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { lazy, useState, useEffect, Suspense } from 'react';
import { LogoWordmark } from '@cbhq/cds-web/icons/LogoWordmark';
import { palette } from '@cbhq/cds-web/tokens';
import { componentsThemeMap } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import { useWindowResize } from '../../hooks/useWindowResize.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import { useLogger } from '../../providers/LoggerProvider.js';
import { CoinbaseLogo } from '../../ui/CoinbaseLogo.js';
import '../../ui/Div/index.js';
import '../../ui/Image/index.js';
import '../../ui/Link/index.js';
import { LinkButton } from '../../ui/Link/LinkButton.js';
import { LinkPressable } from '../../ui/Link/LinkPressable.js';
import { SkeletonLoader } from '../../ui/SkeletonLoader.js';
import { modifyLoginUrlPerEnvironment } from '../../utils/modifyLoginUrlPerEnvironment.js';
import { BurgerButton } from './BurgerButton.js';
import { NAVBAR_MAX_WIDTH, NAVBAR_NAV_HEIGHT, NAVBAR_LOGO_WIDTH, NAVBAR_LOGO_HEIGHT, NAVBAR_SECONDARY_LOGO_WIDTH } from './constants.js';
import { Navlink } from './Navlink.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { Image } from '../../ui/Image/Image.js';
import { Link } from '../../ui/Link/Link.js';

// eslint-disable-next-line no-restricted-imports -- TODO Fix this
const LazyMobileMenu = /*#__PURE__*/lazy(async () => ({
  default: (await import('./MobileMenu.js')).MobileMenu
}));
function MainNavbar({
  primaryLogoHref,
  primaryLogoImageUrl,
  navLinks,
  secondaryCtaLabel,
  secondaryCtaUrl,
  primaryCtaLabel,
  primaryCtaUrl,
  hasBanner,
  style = 'default',
  secondaryLogo,
  secondaryLogoHref,
  showSecondaryLogoOnMobile,
  regionDropdownCTA,
  customSignInCTA,
  contactUsUrl,
  contactUsText,
  customLogoHeight
}) {
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
  const handleCloseTrapdoor = () => setActiveTab(undefined);
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobileMenuOpen = _useState4[0],
    setMobileMenuOpen = _useState4[1];
  const _useState5 = useState(secondaryCtaUrl),
    _useState6 = _slicedToArray(_useState5, 2),
    envSecondaryCtaUrl = _useState6[0],
    setEnvSecondaryCtaUrl = _useState6[1];
  const _useLogger = useLogger(),
    notifyError = _useLogger.notifyError;
  useEffect(() => {
    try {
      const envUrl = modifyLoginUrlPerEnvironment(secondaryCtaUrl);
      if (secondaryCtaUrl !== envUrl) setEnvSecondaryCtaUrl(envUrl);
    } catch (error) {
      notifyError('Error modifying login URL', error.message);
    }
  }, [secondaryCtaUrl]);
  useWindowResize(() => setMobileMenuOpen(false));

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
  const toggleIsOpen = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop, @typescript-eslint/no-explicit-any -- TODO Fix this
  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      toggleIsOpen();
    }
    if (event.key === 'Escape' && isMobileMenuOpen) {
      setMobileMenuOpen(false);
    }
  };
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    background = _componentsThemeMap$s.background;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Div, {
      as: "nav",
      width: "100%",
      zIndex: 3,
      justifyContent: "center",
      flexDirection: "column",
      background: background,
      alignItems: "center",
      css: {
        borderBottom: `1px solid ${palette.line}`
      },
      children: /*#__PURE__*/jsxs(Div, {
        maxWidth: NAVBAR_MAX_WIDTH,
        height: NAVBAR_NAV_HEIGHT,
        width: "100%",
        spacingHorizontal: 3,
        onMouseLeave: handleCloseTrapdoor,
        background: background,
        children: [/*#__PURE__*/jsxs(Div, {
          justifyContent: "flex-start",
          flexGrow: 2,
          flexBasis: {
            sm: 'auto',
            lg: NAVBAR_LOGO_WIDTH
          },
          alignItems: "center",
          onMouseEnter: handleCloseTrapdoor,
          children: [!secondaryLogo && /*#__PURE__*/jsx(LinkPressable, {
            href: primaryLogoImageUrl ? secondaryLogoHref || primaryLogoHref : primaryLogoHref || '/',
            "data-qa": ANALYTICS_KEY.MainLogo,
            children: primaryLogoImageUrl ? /*#__PURE__*/jsx(Div, {
              width: "auto",
              height: customLogoHeight && primaryLogoImageUrl ? customLogoHeight : NAVBAR_LOGO_HEIGHT,
              css: {
                img: {
                  width: 'auto'
                }
              },
              children: /*#__PURE__*/jsx(Image, {
                src: primaryLogoImageUrl,
                alt: "Logo",
                priority: true,
                loading: "eager"
              })
            }) : /*#__PURE__*/jsx(Div, {
              width: NAVBAR_LOGO_WIDTH,
              height: NAVBAR_LOGO_HEIGHT,
              children: /*#__PURE__*/jsx(CoinbaseLogo, {})
            })
          }), !!secondaryLogo && /*#__PURE__*/jsx(LinkPressable, {
            href: secondaryLogoHref || primaryLogoHref || '',
            "data-qa": ANALYTICS_KEY.MainLogoHelpCenter,
            children: /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsx(Div, {
                width: NAVBAR_SECONDARY_LOGO_WIDTH,
                height: NAVBAR_LOGO_HEIGHT,
                display: {
                  sm: showSecondaryLogoOnMobile ? 'flex' : 'none',
                  lg: 'flex'
                },
                children: secondaryLogo
              }), !showSecondaryLogoOnMobile && /*#__PURE__*/jsx(Div, {
                width: NAVBAR_LOGO_WIDTH,
                height: NAVBAR_LOGO_HEIGHT,
                display: {
                  sm: 'flex',
                  lg: 'none'
                },
                children: /*#__PURE__*/jsx(LogoWordmark, {})
              })]
            })
          })]
        }), /*#__PURE__*/jsx(Div, {
          justifyContent: "center",
          flexGrow: 6,
          flexBasis: {
            sm: 'auto',
            lg: 0
          },
          display: {
            sm: 'none',
            lg: 'flex'
          },
          children: navLinks && navLinks?.map(({
            url,
            label,
            trapdoorLinks,
            productLink
          }, index) => /*#__PURE__*/jsx(AnalyticsProvider, {
            analyticsPrefix: `${ANALYTICS_KEY.Navlink}${index}`,
            children: /*#__PURE__*/jsx(Navlink, {
              url: url,
              label: label,
              trapdoorLinks: trapdoorLinks || [],
              productLink: productLink,
              activeTab: activeTab,
              setActiveTab: setActiveTab,
              hasBanner: hasBanner,
              color: foreground
            })
          }, `${index}-${label}`))
        }), /*#__PURE__*/jsxs(Div, {
          justifyContent: "flex-end",
          alignItems: "center",
          flexGrow: 2,
          flexBasis: 0,
          onMouseEnter: handleCloseTrapdoor,
          children: [/*#__PURE__*/jsx(Div, {
            spacingHorizontal: 2,
            css: {
              'span:hover': {
                color: palette.primary
              }
            },
            display: {
              sm: 'none',
              lg: 'flex'
            },
            children: secondaryCtaLabel && /*#__PURE__*/jsx(Link, {
              href: envSecondaryCtaUrl || '',
              variant: "label1",
              "data-qa": ANALYTICS_KEY.SecondaryCtaLabel,
              children: /*#__PURE__*/jsx(Div, {
                as: "span",
                color: foreground,
                children: secondaryCtaLabel
              })
            })
          }), primaryCtaUrl && primaryCtaLabel && /*#__PURE__*/jsx(Div, {
            display: "contents",
            children: /*#__PURE__*/jsx(LinkButton, {
              compact: true,
              href: primaryCtaUrl,
              "data-qa": ANALYTICS_KEY.PrimaryCtaLabel,
              children: primaryCtaLabel
            })
          }), /*#__PURE__*/jsxs(Div, {
            children: [regionDropdownCTA && /*#__PURE__*/jsx(Div, {
              display: {
                sm: 'none',
                lg: 'contents'
              },
              children: regionDropdownCTA
            }), !!customSignInCTA && customSignInCTA]
          }), /*#__PURE__*/jsx(Div, {
            onClick: toggleIsOpen,
            onKeyDown: handleKeyPress,
            spacing: 1,
            css: {
              tabIndex: 0,
              margin: '10px -10px 10px 20px'
            },
            display: {
              sm: 'flex',
              lg: 'none'
            },
            children: /*#__PURE__*/jsx(BurgerButton, {
              isOpen: isMobileMenuOpen
            })
          })]
        })]
      })
    }), isMobileMenuOpen && /*#__PURE__*/jsx(Div, {
      as: "nav",
      width: "100%",
      flexDirection: "column",
      zIndex: 2,
      children: /*#__PURE__*/jsx(Suspense, {
        fallback: /*#__PURE__*/jsx(SkeletonLoader, {}),
        children: /*#__PURE__*/jsx(LazyMobileMenu, {
          navLinks: navLinks,
          secondaryCtaLabel: secondaryCtaLabel,
          secondaryCtaUrl: envSecondaryCtaUrl,
          primaryCtaLabel: primaryCtaLabel,
          primaryCtaUrl: primaryCtaUrl
          // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
          ,

          handleClose: () => setMobileMenuOpen(false),
          hasBanner: hasBanner,
          contactUsUrl: contactUsUrl,
          contactUsText: contactUsText
        })
      })
    })]
  });
}
export { MainNavbar };
//# sourceMappingURL=MainNavbar.js.map
